import React from 'react';
import * as PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import {withStyles} from '@material-ui/core/styles';
import AddBoxIcon from '@material-ui/icons/AddBox';
import StopIcon from '@material-ui/icons/Stop';
import StopOutlinedIcon from '@material-ui/icons/StopOutlined';
import Tooltip from '@material-ui/core/Tooltip';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

const LAYOUT_MAX_NUM = 20;

const styles = theme => ({
    root: {
        margin: 'auto',
        textAlign: 'center',
    },
    icon: {
        width: 40,
        height: 40
    },
    layoutItemContainer: {
        display: 'flex',
        flexDirection: 'column',
    },
});

export class LayoutSwitchList extends React.Component {
    render() {

        return (
            <div className={this.props.className}>
                {this.props.layoutArray.map((row, i) => {
                    return (
                        <div key={i} className={this.props.classes.layoutItemContainer}>
                            <IconButton
                                key={i}
                                color={'primary'}
                                onClick={() => {
                                    this.props.onClickLayout(row);
                                }}
                            >
                                {i === this.props.currentLayoutIndex ?
                                    <StopIcon className={this.props.classes.icon}/> : <StopOutlinedIcon className={this.props.classes.icon}/>
                                }
                            </IconButton>
                            {i === this.props.currentLayoutIndex &&
                                <div>
                                    {i !== 0 &&
                                            <IconButton
                                                size="small"
                                                variant="outlined"
                                                onClick={() => this.props.onClickLayoutRearrangeLeft()}
                                                disabled={this.props.isDisabled}
                                            >
                                                <Tooltip title="レイアウトを左へ移動"><ArrowBackIcon /></Tooltip>
                                            </IconButton>
                                    }
                                    {i !== this.props.layoutArray.length - 1 &&
                                        <IconButton
                                            size="small"
                                            variant="outlined"
                                            onClick={() => this.props.onClickLayoutRearrangeRight()}
                                            disabled={this.props.isDisabled}
                                        >
                                            <Tooltip title="レイアウトを右へ移動"><ArrowForwardIcon /></Tooltip>
                                        </IconButton>
                                    }
                                </div>
                            }
                        </div>
                    )
                })}
                <div className={this.props.classes.layoutItemContainer}>
                    <IconButton
                        color={'primary'}
                        onClick={this.props.onClickAdd}
                        disabled={this.props.layoutArray.length >= LAYOUT_MAX_NUM || this.props.isDisabled}
                        >
                        <AddBoxIcon className={this.props.classes.icon}/>
                    </IconButton>
                </div>
            </div>
        );
    }
}

LayoutSwitchList.propTypes = {
    className: PropTypes.string,
    currentLayoutIndex: PropTypes.number.isRequired,
    layoutArray: PropTypes.array.isRequired,
    onClickAdd: PropTypes.func.isRequired,
    onClickLayout: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool.isRequired,
};

export default withStyles(styles)(LayoutSwitchList);
